import React from "react";
import ReportNav from "./ReportNav.";
import ReactProSidebar from "../Admin/Dashboard/ReactProSidebar";
import NavBar from "../Admin/Dashboard/NavBar";

function ReportGen() {
  return (
    <div className="container">
      <ReportNav />

      <ReactProSidebar />
    </div>
  );
}

export default ReportGen;
